export default class SocketFactory {
  constructor(private _url: string) {}

  public getSocket(): WebSocket {
    return new WebSocket(this._url);
  }
}
